import { c as _c } from "react/compiler-runtime";
import { ChannelMenu } from './all/ChannelMenu';
import { CustomerMenu } from './all/CustomerMenu';
import { MyInfoMenu } from './all/MyInfoMenu';
import { MyMenu } from './all/MyMenu';
export function AllMenu() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="w-full"><MyMenu /><ChannelMenu /><CustomerMenu /><MyInfoMenu /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}